<div class="coworking-services" *ngIf="form.controls.length">
  <div class="essentials">
    <h3>{{ "coworking.services.essentials" | translate }}</h3>
    <div class="inline">
      <div
        class="wrapper"
        [formGroup]="getFormGroup('Essentials')"
        *ngFor="let control of getFormGroup('Essentials').controls | keyvalue"
      >
        <cowing-essential-service
          [control]="control.value"
          [isForm]="true"
        ></cowing-essential-service>
      </div>
    </div>
  </div>
  <div class="covid">
    <h3>{{ "coworking.services.covid" | translate }}</h3>
    <div class="inline" [formGroup]="getFormGroup('Free Covid')">
      <cowing-essential-service
        [control]="getFormGroup('Free Covid').get('PolÃ­tica Covid-free')"
        [isForm]="true"
      >
      </cowing-essential-service>
      <div class="grid">
        <div
          class="wrapper"
          *ngFor="let control of getFormGroup('Free Covid').controls | keyvalue"
        >
          <cowing-checkbox
            *ngIf="control.value['rawValue'].label !== 'PolÃ­tica Covid-free'"
            [isForm]="true"
            [control]="control.value"
          ></cowing-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="others">
    <h3>{{ "coworking.services.others" | translate }}</h3>
    <div class="container">
      <div
        class="wrapper"
        *ngFor="let control of getFormGroup('Others').controls | keyvalue"
      >
        <cowing-checkbox
          [isForm]="true"
          [control]="control.value"
        ></cowing-checkbox>
      </div>
    </div>
  </div>
  <div *ngIf="isEditingInfo" class="actions-footer">
    <cowing-button
      [label]="'coworking.back' | translate"
      [type]="EButtonType.RoundedSecondary"
      [iconShow]="false"
      (event)="goBack()"
    >
    </cowing-button>
    <cowing-button
      [disabled]="isDisabledForm"
      [label]="'Guardar'"
      [type]="EButtonType.Rounded"
      [iconShow]="false"
      (event)="putSpaces()"
    >
    </cowing-button>
  </div>
</div>
